import type { Option } from 'models/forms.types';

export const TEST_INTERPRETER_LANGUAGES =
  import.meta.env.VITE_ENV === 'production'
    ? []
    : [
        {
          language: 'Test Video',
          sipAddress: 'test-siptestlls@sip.languageline.com',
          type: 'video'
        },
        {
          language: 'Test Audio',
          sipAddress: 'test-audio-siptestlls@sip.languageline.com',
          type: 'audio'
        }
      ];

/** MultiSelect may return an array; we treat selection as single and use the last selected item. */
export const getSingleSelectedOption = (data: unknown): Option | undefined => {
  if (!data) return undefined;
  const arr = Array.isArray(data) ? data : [data];
  const item = arr.at(-1);
  return item && typeof item === 'object' && 'label' in item && 'value' in item
    ? (item as Option)
    : undefined;
};
